import { Box, Divider } from '@mui/material';
import { ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { QUICK_START_STEP } from 'modules/quick-start/constants';
import { TextInput } from '../text-input';
import { getStyles } from './styles';
import { QuickStartTitle } from '../quick-start-title';
import { LoginLinkArea } from '../login-link-area';

interface Props {
  type?: string;
}

export function QuickAuthContent({ type }: Props): ReactElement {
  const styles = getStyles();
  const { t } = useTranslation();

  const { submitForm } = useFormikContext<QuickStartTypes.Form>();

  return (
    <Box sx={styles.contentBar}>
      <Box sx={styles.content}>
        <QuickStartTitle />
        <Box sx={styles.inputWrapper}>
          <TextInput label={t('quick-start.email')} name="email" />
          <Divider />
          <TextInput label={t('quick-start.password')} name="password" type="password" />
          {type === QUICK_START_STEP.SIGNUP && (
            <>
              <Divider />
              <TextInput label={t('quick-start.confirm-password')} name="confirmPassword" type="password" />
            </>
          )}
        </Box>
        <Box sx={styles.connect} onClick={submitForm}>
          <Trans i18nKey="quick-start.continue">Continue</Trans>
        </Box>
        {type === QUICK_START_STEP.SIGNUP && <LoginLinkArea />}
      </Box>
    </Box>
  );
}
